export function buildQs(data) {
    const esc = encodeURIComponent;
    return Object.keys(data)
        .filter(k => data[k] !== undefined && data[k] !== '')
        .flatMap(k => 
            Array.isArray(data[k]) 
                ? data[k].map(value => `${esc(k)}=${esc(value)}`) 
                : `${esc(k)}=${esc(data[k])}`
        )
        .join('&');
}